/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { memberResolveResultSchema } from './memberResolveResultSchema';

export const resolveMembersResponseSchema = z.object({
  get results() {
    return z.array(memberResolveResultSchema);
  },
});
